import { createContext, useContext, useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const Ctx = createContext({ items: [], sections: {} });

export const GalleryProvider = ({ children }) => {
  const [data, setData] = useState({ items: [], sections: {} });
  useEffect(() => {
    fetch(`${API}/api/gallery`).then((r) => r.json()).then((d) => setData({ items: d.items || [], sections: d.sections || {} })).catch(() => {});
  }, []);
  return <Ctx.Provider value={data}>{children}</Ctx.Provider>;
};

export const useGallery = () => useContext(Ctx);
